import React from "react";
import { Router, Route } from "react-router-dom";
import { Redirect, Switch } from "react-router";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
// import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { connect } from "react-redux";
import { Login } from "./modules";
import { history } from "./managers/history";
import BaseComponent from "./modules/baseComponent";
import LoaderComponent from "./common/components/loader";
import { createMuiTheme } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import Dashboard from "./modules/dashboard";
class Routes extends BaseComponent {
  componentDidMount() {}

  //Common component to render the Toast-
  toast = () => {
    return (
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnVisibilityChange={false}
        draggable={false}
        pauseOnHover={false}
        closeButton={null}
      />
    );
  };

  getPublicRoutes = () => {
    return (
      <Switch>
        <Route exact path={"/"} component={Login} />
        <Redirect exact from="*" to="/" />
      </Switch>
    );
  };
  getPrivateRoutes = () => {
    return (
      <Switch>
        <Route exact path={"/"} component={Login} />
        <Route exact path={"/dashboard"} component={Dashboard} />
        <Route exact path={"/dashboard/:menu"} component={Dashboard} />
        <Route exact path={"/dashboard/:menu/:subMenu"} component={Dashboard} />
        <Redirect exact from="*" to="/" />
      </Switch>
    );
  };

  render() {
    let loader =
      this.props && this.props.user && this.props.user.loading ? (
        <LoaderComponent />
      ) : null;
    let isUserLoggedIn =
      this.props && this.props.user && this.props.user.userDetails;
    // console.log("isUserLoggedIn", this.props);
    // console.log("isUserLoggedIn", isUserLoggedIn);
    return (
      <MuiThemeProvider muiTheme={createMuiTheme()}>
        <Router history={history}>
          {loader}
          {this.toast()}
          {isUserLoggedIn ? this.getPrivateRoutes() : this.getPublicRoutes()}
        </Router>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.user };
};
export default connect(mapStateToProps)(Routes);
